import { connect } from 'react-redux'
import React, { Component } from 'react'
import { browserHistory, Link } from 'react-router'
import BlueLogo from '../../assets/newblacklogo.png'
import Plan from '../landing/Plan'
import './pricing.css'
import { Helmet } from "react-helmet";
import FaPlus from 'react-icons/lib/io/plus'
import FaMinus from 'react-icons/lib/io/minus'
import GlobalFooter from '../../nav/GlobalFooter'

const mapStateToProps = (state, ownProps) => ({
  me: state.me,
})
  
class Pricing extends Component {
  constructor() {
    super()
    this.setState = this.setState.bind(this)
  }

  render() {
    const { me, viewParams } = this.props
    const { query } = viewParams
    const isPro = me.plan && me.plan != ''

    let src_internal = query.src_internal || 'pricing'

    return (
      <div className={`pricing ${me.no_trial ? 'notrial' : ''}`}>
        <Helmet>
          <title>{window._STM_PREDATA.pricing.title}</title>
          <meta name="description" content={window._STM_PREDATA.pricing.description}></meta>
          <link rel="canonical" href={`https://streamable.com/pricing`} />
        </Helmet>
        <div className="background-top"></div>
        <div className="acquisition-banner">We're excited to announce that Streamable has been acquired by Hopin! <a href="https://streamable.com/resources/streamable-acquired-by-hopin/" target="_blank">Read more →</a></div>
        <nav className="navbar navbar-default">
          <ul className="nav navbar-nav">
            <li>
              <a href="https://streamable.com" className="nav-btn logo-btn">
                <img className="logo" src={BlueLogo} role="presentation" />
              </a>
            </li>
          </ul>
        </nav>
        <div className="header">
          <h1>Choose your plan.</h1>
          <p>Simple, easy-to-understand pricing. Try our Pro plan free for 7 days &mdash; cancel anytime if you're unsatisfied.</p>
        </div>
        <div className="plans">
          <Plan
            title="Free"
            description="Free, ad-supported video hosting great for just getting started"
            cost="$0"
            items={[
              {
                'name': '90 day video retention',
                'description': 'Your videos will be removed after three months of inactivity.'
              },
              {
                'name': 'Ad-supported playback',
                'description': 'Viewers will see advertising on your popular videos.'
              },
              {
                'name': 'Stream your videos in HD',
                'description': 'Your videos will stream in HD resolution (up to 720p 60fps).'
              },
              {
                'name': '250 MB / 10 min limit per video',
                'description': 'Uploads are capped at 250 MB and your videos cannot be longer than 10 minutes.'
              }
            ]}
            action={me.user_name ? (isPro ? 'Downgrade' : 'Current Plan') : 'Start for free'}
            className="plan-free"
            duration="forever free"
            disabled={me.user_name && !isPro}
            onClick={async () => {
              if (this.props.me.user_name) {
                browserHistory.push('/billing?cancel=true')
              } else {
                browserHistory.push('/signup?signup_src=pricing')
              }
            }}
          >
          </Plan>
          {me.plan_price || me.plan_options ?
          <Plan
            title="Professional"
            description="The perfect choice for individuals and businesses uploading video"
            cost={'$' + (me.plan ? (me.plan_annual ? (me.plan_price / 12).toFixed(2) : me.plan_price) : (me.plan_options['annual']['price'] / 12).toFixed(2))}
            banner="Most Popular"
            items={[
              {
                'name': '2 TB cloud storage',
                'description': '2 TB (2,000GB) of storage space included with every Pro plan.'
              },
              {
                'name': 'No ads on your videos',
                'description': 'Viewers will never see ads on any of your videos.'
              },
              {
                'name': 'Stream in 4K Ultra HD',
                'description': 'Stream your videos in 4K UHD resolution (up to 2160p 60fps).'
              },
              {
                'name': 'No limit on video size or length',
                'description': 'Upload and clip video files of any size or duration.'
              }
            ]}
            durationOptions={me.plan ? false : [
              {
                title: `<b>$${(me.plan_options['annual']['price'] / 12).toFixed(2)}</b> per month, billed annually`,
                onClick: () => {
                  try {                 
                    browserHistory.push(`/upgrade?src_internal=${src_internal}`)
                  } catch {
                    browserHistory.push('/upgrade')
                  }
                }
              },
              {
                title: `<b>$${me.plan_options['monthly']['price']}</b> per month, billed monthly`,
                onClick: () => {
                  try {
                    browserHistory.push(`/upgrade?monthly=true&src_internal=${src_internal}`)
                  } catch {
                    browserHistory.push('/upgrade?monthly=true')
                  }
                }
              }
            ]}
            duration={me.plan ? me.plan_annual ? 'billed annually' : 'billed monthly' : null}
            action={isPro ? "Current plan" : me.no_trial ? 'Upgrade Now' : 'Start free trial'}
            className="plan-pro"
            disabled={isPro}
            onClick={() => {
              try {
                browserHistory.push(`/upgrade?plan=annual&src_internal=${src_internal}`)
              } catch {
                browserHistory.push('/upgrade?plan=annual')
              }
            }}
          >
          </Plan>
          : ''}
          <Plan
            title="Business"
            description="Custom pricing for high-volume storage and streaming needs"
            cost="$199"
            className="plan-custom"
            items={[
              {
                'name': 'Everything included in Pro',
                'description': 'All the features included in the Streamable Pro plan.'
              },
              {
                'name': 'Custom bandwidth pricing',
                'description': 'Custom rates for large amounts of storage or bandwidth.'
              },
              {
                'name': 'Google Analytics integration',
                'description': 'Add your Google Analytics ID to track campaign performance.'
              },
              {
                'name': 'Priority business support',
                'description': 'Get 24/7 access to our business support staff.'
              }
            ]}
            duration="depending on usage"
            frequency="per month and up"
            action="Contact Sales"
            disabled={false}
            onClick={async () => {
              window.open('mailto:sales@streamable.com?subject=Business%20pricing', '_blank');
            }}
          >
          </Plan>
        </div>
        <div className="faq">
          {me.no_trial ? '' :
          <div className="faq-item expanded">
            <FaPlus className="plus" onClick={e => e.currentTarget.parentNode.classList.add('expanded')} /><FaMinus className="minus" onClick={e => e.currentTarget.parentNode.classList.remove('expanded')}/>
            <div className="faq-question">
              Can I cancel my free trial?
            </div>
            <div className="faq-answer">
              All trials are zero-commitment and can be cancelled at any time in your account settings. If you decide to cancel during the trial period, you won't pay a dime.
            </div>
          </div>
          }
          <div className="faq-item">
            <FaPlus className="plus" onClick={e => e.currentTarget.parentNode.classList.add('expanded')} /><FaMinus className="minus" onClick={e => e.currentTarget.parentNode.classList.remove('expanded')}/>
            <div className="faq-question">
              Will viewers see ads on my videos?
            </div>
            <div className="faq-answer">
              Viewers will never see ads on your videos if you're on the Pro or Business plan. On the free plan, ads will appear next to your videos when they are shared.
            </div>
          </div>
          <div className="faq-item">
            <FaPlus className="plus" onClick={e => e.currentTarget.parentNode.classList.add('expanded')} /><FaMinus className="minus" onClick={e => e.currentTarget.parentNode.classList.remove('expanded')}/>
            <div className="faq-question">
              How long are videos stored?
            </div>
            <div className="faq-answer">
              On the Pro or Business plan, videos are only deleted upon your request. On the free plan, videos are deleted after 90 days.
            </div>
            </div>
          <div className="faq-item">
            <FaPlus className="plus" onClick={e => e.currentTarget.parentNode.classList.add('expanded')} /><FaMinus className="minus" onClick={e => e.currentTarget.parentNode.classList.remove('expanded')}/>
            <div className="faq-question">
              How much bandwidth do I get?
            </div>
            <div className="faq-answer">
              The Pro plan comes with 1 terabyte of bandwidth (1,000GB) included per month. If you need more bandwidth, please <a href="mailto:sales@streamable.com?Subject=Custom%20bandwidth">reach out to us</a>.
            </div>
          </div>
          <div className="faq-item">
            <FaPlus className="plus" onClick={e => e.currentTarget.parentNode.classList.add('expanded')} /><FaMinus className="minus" onClick={e => e.currentTarget.parentNode.classList.remove('expanded')}/>
            <div className="faq-question">
              What if I need a different plan?
            </div>
            <div className="faq-answer">
              Please email <a href="mailto:sales@streamable.com?Subject=Custom%20plan">sales@streamable.com</a> to set up a custom plan.
            </div>
          </div>
        </div>
        <div className="footer">
          <div className="background" />
          <GlobalFooter />
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps)(Pricing)
